<template>
  <div class="init d-flex w-100 h-100 flex-column">
      <main role="main" class="inner cover text-center">
        <transition name="slide-fade-init" >
          <div v-if="showLogo" class="create-user">
             <img style="width: 120px; margin-bottom: 50px" src="@/assets/images/logo.png" alt="logo"/>
             <form id="null" @submit="checkForm" action="#" class="create">
                  <input class="m-top" type="text" id="email" v-model="email" name="email" placeholder="CORREO ELECTRÓNICO" />
                  <input class="m-top" type="password" id="pass" v-model="pass" name="pass" placeholder="CONTRASEÑA" />
                  <input type="submit" value="CONTINUE" class="btn_white m-top" />
              </form>
              <p class="error" v-if="errors.length">
                <ul>
                  <li v-for="error in errors" :key="error">{{ error }}</li>
                </ul>
              </p>
          </div>
        </transition>
      </main>
      <footer class="mastfoot mt-auto text-center">
        <div class="inner">
          <p>Derechos reservados - v1.0</p>
        </div>
      </footer>
  </div>
</template>

<script>

//import VFacebookLogin from 'vue-facebook-login-component'
//import GoogleLogin from 'vue-google-login';

export default {
  
  name: 'Login',
  data () {
    return {
      // client_id is the only required property but you can add several more params, full list down bellow on the Auth api section
      params: {
      },
      errors: [],
      email: null,
      pass: null,
      show: false,
      showLogo: false,
      isAuthenticated: false,
      roleAdmin: "ObY4XrMPGZ"
    }
  },
  beforeMount(){
    setTimeout(() => this.showLogo = true, 300);
    setTimeout(() => this.show = true, 1300);
  },
  methods:{
    
    checkForm: function (e) {
      const user = new this.$parse.User();
      
      user.setUsername(this.email);
      user.setPassword(this.pass);
      
      user.logIn()
        .then((res) => {
          if( res.attributes.role.id == this.roleAdmin){
            this.$router.push('/dashboard');
          } else {
            this.errors.push("Access denied");
          }
        })
        .catch((error) => {
          this.errors.push(error);
        });
      e.preventDefault();
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.cover-container {
  max-width: 42em;
}

/*
 * Cover
 */
.cover {
  padding: 0 1.5rem;
  margin: auto !important;
}

.logo p{
  width: 118px;
  height: 130px;
  font-family: 'Work Sans semibold', Helvetica, Arial, sans-serif;
  font-size: 30px;
  margin: 1em auto;
  padding: 0;
  text-align: left;
  font-weight: 600;
}

.m-bottom{
 margin-bottom: 1em;
}

.m-top{
  margin-top: 1.2em;
}

.create input{
  margin-bottom: 1em;
}

.create input[type=text],[type=password]{
  background: #FAFAFA;
  color: #000;
  border: 0;
  outline: 0;
  border-bottom: 1px solid #000;
  width: 100%;
  height: 45px;
}
.create [type=submit]{
  margin-top: 1.5em;
}

.create-user{
  width: 265px;
}

::placeholder { /* Firefox, Chrome, Opera */ 
    color: #000; 
} 
  
:-ms-input-placeholder { /* Internet Explorer 10-11 */ 
    color: #000; 
} 
  
::-ms-input-placeholder { /* Microsoft Edge */ 
    color: #000; 
}

.title{
  font-family: 'Work Sans semibold', Helvetica, Arial, sans-serif;
  font-weight: 600;
}

.btn_white{
  background: #000;
  border: 0;
  color: #fff;
  height: 40px;
  padding: 0 15px;
}

button.g {
  display: inline-block;
  width: 100%;
  height: 40px;
  padding: 0;
  background: #D4D4D4;
  color: #fff;
  text-decoration: none;
  line-height: 1;
  position: relative;
  border-radius: 20px;
  border: 0;
}

button.g img {
  height: 25px;
}


button.fb {
  display: inline-block;
  width: 100%;
  height: 40px;
  padding: 0;
  background: #3A5A97;
  color: #fff;
  text-decoration: none;
  line-height: 1;
  position: relative;
  border-radius: 20px;
  border: 0;
  text-transform: UPPERCASE !important;
}

button.fb img {
  height: 25px;
}




a.g {
    display: inline-block;
    width: 100%;
    height: 40px;
    padding: 12px 0 0 25px;
    background: #D4D4D4;
    color: #fff;
    text-decoration: none;
    line-height: 1;
    position: relative;
    border-radius: 20px;
}

.m-login{
  font-family: 'Work Sans medium', Helvetica, Arial, sans-serif;
  color: #fff;
}


/*
 * Footer
 */
.mastfoot p{
  font-size: 12px;
}

.mastfoot p a{
  color: #fff;
  font-family: 'Work Sans bold', Helvetica, Arial, sans-serif;
  font-size: 12px;
}

/*
* Animation
*/

.slide-fade-init-enter-active {
  transition: all 1s ease;
}

.slide-fade-init-enter, .slide-fade-init-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

/*
* Error 
*/

.error {
  color: red;
  font-size: 12px;
}

.error ul {
  padding: 0;
  list-style: none;
}


</style>
